<div class="portal-wrapper bg-light min-vh-100 py-5">
  <div class="container">
    
    <!-- HEADER DEL PORTAL -->
    <div class="d-flex justify-content-between align-items-center mb-5">
      <div class="d-flex align-items-center">
        <img src="assets/logo.png" alt="ServiTrack" class="me-3" style="max-height: 50px;">
        <h2 class="fw-bold mb-0 text-dark">Portal de Clientes</h2>
      </div>
      <div *ngIf="authService.user$ | async as user" class="dropdown">
        <button class="btn btn-white border rounded-pill px-4 dropdown-toggle shadow-sm" type="button" data-bs-toggle="dropdown">
          <i class="bi bi-person-circle me-2"></i>{{ user.name }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-16">
          <li><a class="dropdown-item py-2" (click)="authService.logout()"><i class="bi bi-box-arrow-right me-2"></i>Cerrar Sesión</a></li>
        </ul>
      </div>
    </div>

    <!-- VISTA: NO LOGUEADO (LOGIN / SIGNUP) -->
    <div *ngIf="!(authService.user$ | async)" class="row justify-content-center animate-fade-in">
      <div class="col-md-5">
        <div class="card border-0 shadow-lg rounded-24 p-4 p-md-5 text-center bg-white">
          <h3 class="fw-bold mb-4">Bienvenido a ServiTrack</h3>
          <p class="text-muted mb-5">Accede para ver el estatus de tus bicicletas y tu historial de servicios.</p>
          
          <button class="btn btn-dark w-100 rounded-pill py-3 mb-3 fw-bold shadow" (click)="authService.loginWithGoogle()">
            <i class="bi bi-google me-2"></i> Continuar con Google
          </button>
          
          <div class="separator my-4 text-muted small">o usa tu correo electrónico</div>
          
          <button class="btn btn-outline-primary w-100 rounded-pill py-3 fw-bold" routerLink="/login">
            Iniciar Sesión / Registrarse
          </button>
        </div>
      </div>
    </div>

    <!-- VISTA: LOGUEADO (LISTA DE ÓRDENES) -->
    <div *ngIf="authService.user$ | async" class="animate-fade-in">
      <div class="row mb-4">
        <div class="col-12">
          <h4 class="fw-bold"><i class="bi bi-bicycle me-2 text-primary"></i>Mis Bicicletas en Taller</h4>
        </div>
      </div>

      <div class="row g-4">
        <div *ngFor="let work of myWorks$ | async" class="col-md-6 col-lg-4">
          <div class="card border-0 shadow-sm rounded-24 h-100 work-card transition-all">
            <div class="card-body p-4">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <span class="badge bg-light text-dark border small mb-2">{{ work.caseNumber }}</span>
                  <h5 class="fw-bold mb-0">{{ work.bikeDescription }}</h5>
                </div>
                <span class="badge rounded-pill px-3 py-2" [ngClass]="getStatusClass(work.currentStatus)">
                  {{ getSpanishStatus(work.currentStatus) }}
                </span>
              </div>
              
              <div class="p-3 bg-light rounded-20 mb-3 border">
                <small class="text-muted text-uppercase fw-bold d-block mb-1 small-font">Tipo de Servicio</small>
                <div class="fw-bold text-primary">{{ work.serviceType }}</div>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <div class="text-muted small">
                  <i class="bi bi-calendar-event me-1"></i> {{ work.entryDate?.toDate() | date:'dd MMM yyyy' }}
                </div>
                <div class="fw-bold fs-5 text-dark">
                  {{ work.totalPrice | currency }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="(myWorks$ | async)?.length === 0" class="col-12 text-center py-5">
           <div class="icon-circle bg-white shadow-sm mx-auto mb-4" style="width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; border-radius: 50%;">
             <i class="bi bi-bicycle fs-1 text-light"></i>
           </div>
           <h5 class="text-muted">No tienes órdenes activas en este momento.</h5>
           <p class="text-muted small">Cuando traigas tu bici al taller, aparecerá aquí automáticamente.</p>
        </div>
      </div>
    </div>

  </div>
</div>